<div
    [class.order--padded]="
        (((navigation$ | async) &&
            activeRouteConfiguration['child_callback_for_bottom_bar'] &&
            !activeRouteConfiguration['hide_bottom_bar_before_callback']) ||
            ((status$ | async) !== 'draft' &&
                activeRouteConfiguration &&
                !activeRouteConfiguration['hide_bottom_bar'])) &&
        !routeData.hide_bottom_bar
    "
    [class.white-background]="hasWhiteBackground"
    class="order"
>
    <span *ngIf="!isLoading && !isNavigating; else superloader"></span>
    <vat-switch
        *ngIf="countryHasVAT && !isLoading && !isNavigating && orderState && isTablet && !isLastStep"
        [class.specific-vat-switch]="routeData?.specificVatSwitch"
    ></vat-switch>
    <router-outlet style="width: 100%"></router-outlet>
    <div
        *ngIf="
            (((navigation$ | async) &&
                activeRouteConfiguration['child_callback_for_bottom_bar'] &&
                !activeRouteConfiguration['hide_bottom_bar_before_callback']) ||
                ((status$ | async) !== 'draft' &&
                    activeRouteConfiguration &&
                    !activeRouteConfiguration['hide_bottom_bar']) ||
                (routeData && routeData.forceDisplayBottomBar)) &&
            !routeData.hide_bottom_bar
        "
        [@enterAnimationFooter]
        class="bar-container"
    >
        <div class="container">
            <div class="row justify-content-sm-center align-items-center">
                <div class="col-12 col-sm-6 bottom-xs-10 top-xs-10">
                    <div *ngIf="!isItemLoading; else loader" class="bar-container__pricing">
                        <div
                            *ngIf="
                                item &&
                                    item.setup.status !== 'draft' &&
                                    item.attributes.trial === true &&
                                    (price$ | async)?.amountNoVAT === 0;
                                else notTrial
                            "
                        >
                            <span class="bar-container__pricing__title">{{
                                'Essai gratuit de $num$ jours' | transloco : { num: trialPeriod }
                            }}</span>
                            <div
                                *ngIf="item.configuration.setup?.demo?.is_renewable"
                                class="bar-container__pricing__info"
                            >
                                <small
                                    [innerHTML]="
                                        {
                                            textBefore: 'Puis' | transloco,
                                            amount: (realPrice$ | async) || null,
                                            amountDisplay: 'medium',
                                            textAfter: getTextAfter()
                                        } | mycurrency
                                    "
                                ></small>
                                <span
                                    [matTooltipPosition]="'above'"
                                    class="icon icon-information icon-size-18 padding-left-10"
                                    matTooltip="{{
                                        'Ce montant sera uniquement facture ou debite a la fin de votre periode d\'essai de $num$ jours.'
                                            | transloco : { num: trialPeriod }
                                    }}"
                                    matTooltipClass="custom-tooltip"
                                ></span>
                            </div>
                        </div>
                    </div>
                    <ng-template #notTrial>
                        <div
                            *ngIf="
                                item.setup.status !== 'draft' && (price$ | async)?.amountNoVAT !== undefined;
                                else spacer
                            "
                            style="cursor: pointer; line-height: 15px"
                        >
                            <div>
                                <span
                                    *ngIf="
                                        item !== null &&
                                        (price$ | async)?.amountNoVAT !== (realPrice$ | async)?.amountNoVAT
                                    "
                                    [innerHTML]="
                                        {
                                            amount: (price$ | async),
                                            style: 'promotion_sub',
                                            textUnder:
                                                ({ amount: (realPrice$ | async) || null, resultDisplay: 'text' }
                                                | mycurrency)
                                        } | mycurrency
                                    "
                                >
                                </span>
                                <span
                                    *ngIf="
                                        item !== null &&
                                        (price$ | async)?.amountNoVAT === (realPrice$ | async)?.amountNoVAT
                                    "
                                    [innerHTML]="{ amount: (price$ | async), style: 'standard' } | mycurrency"
                                >
                                </span>
                                <span
                                    *ngIf="isStudent && studentServices != ''"
                                    class="icon icon-rounded-star icon-size-30 ml-2 dark-yellow"
                                ></span>
                                <span
                                    *ngIf="isStudent && studentServices != ''"
                                    [tooltip]="studentServices"
                                    class="icon icon-graduate-hat icon-size-12 ml-2 black behind"
                                    tooltipClass="custom-tooltip custom-tooltip--compact"
                                ></span>
                            </div>
                            <div class="bar-container__pricing-label">
                                <small>{{ 'Montant a payer' | transloco }}</small>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="bar-buttons block-buttons align-right justify-right">
                        <button
                            (click)="
                                (activeRouteConfiguration['child_callback_for_back_bottom_bar'] ||
                                    routeData.forceReturnCallBack) &&
                                routeData &&
                                routeData.returnCallBack
                                    ? callChildrenReturnCallback()
                                    : tryNavigate(activeRoute, -1)
                            "
                            *ngIf="!routeData.hideBackButton"
                            [disabled]="pending || isItemLoading || isNavigating"
                            class="back-button"
                            color="accent"
                            mat-raised-button
                        >
                            <span class="icon icon-chevron-left icon-size-16"></span>
                        </button>
                        <span
                            *ngIf="
                                !activeRouteConfiguration['child_callback_for_bottom_bar'] &&
                                !routeData['child_callback_for_bottom_bar']
                            "
                            class="next-button-wrapper"
                        >
                            <button
                                (click)="
                                    routeData && routeData.callback
                                        ? callChildrenCallback()
                                        : tryNavigate(activeRoute, 1)
                                "
                                *ngIf="!isConnected; else Next"
                                [buttonLoader]="isNavigating || pending"
                                [disabled]="pending || (status$ | async) === 'draft' || isItemLoading || isNavigating"
                                [ngClass]="{
                                    'animation-scale':
                                        !pending && (status$ | async) !== 'draft' && !isItemLoading && !isNavigating
                                }"
                                class="btn btn-green"
                                data-testid="btn-order-next"
                                mat-raised-button
                            >
                                <span [ngClass]="{ 'btn__loader--invisible': isNavigating || pending }">{{
                                    (routeData && routeData.text ? routeData.text : 'Suivant') | transloco
                                }}</span>
                            </button>
                            <ng-template #Next>
                                <button
                                    (click)="routeData?.callback ? callChildrenCallback() : tryNavigate(activeRoute, 1)"
                                    *ngIf="!isLastStep; else lastStep"
                                    [buttonLoader]="isNavigating || pending"
                                    [disabled]="
                                        (pending ||
                                            (status$ | async) === 'draft' ||
                                            isItemLoading ||
                                            isNavigating ||
                                            isLoading) &&
                                        (!routeData.callback || routeData.nextButtonDisabled)
                                    "
                                    [ngClass]="{
                                        'animation-scale':
                                            !pending && (status$ | async) !== 'draft' && !isItemLoading && !isNavigating
                                    }"
                                    class="btn btn-green"
                                    data-testid="btn-order-next"
                                    mat-raised-button
                                >
                                    <span [ngClass]="{ 'btn__loader--invisible': isNavigating || pending }">{{
                                        (routeData && routeData.text ? routeData.text : 'Suivant') | transloco
                                    }}</span>
                                </button>
                            </ng-template>
                        </span>
                        <span
                            *ngIf="
                                activeRouteConfiguration['child_callback_for_bottom_bar'] ||
                                routeData['child_callback_for_bottom_bar']
                            "
                            class="next-button-wrapper"
                        >
                            <button
                                (click)="callChildrenCallback()"
                                *ngIf="!isConnected; else Next"
                                [buttonLoader]="isNavigating || pending"
                                [disabled]="
                                    pending ||
                                    isItemLoading ||
                                    isNavigating ||
                                    isLoading ||
                                    (routeData && routeData.nextButtonDisabled)
                                "
                                [ngClass]="{ 'animation-scale': !pending && !isItemLoading && !isNavigating }"
                                class="btn btn-green"
                                data-testid="btn-order-next"
                                mat-raised-button
                            >
                                <span [ngClass]="{ 'btn__loader--invisible': isNavigating || pending }">{{
                                    (routeData && routeData.text ? routeData.text : 'Suivant') | transloco
                                }}</span>
                            </button>
                            <ng-template #Next>
                                <button
                                    (click)="callChildrenCallback()"
                                    *ngIf="!isLastStep; else lastStep"
                                    [buttonLoader]="isNavigating || pending"
                                    [disabled]="
                                        (pending || isItemLoading || isNavigating || isLoading) &&
                                        (!routeData.callback || routeData.nextButtonDisabled)
                                    "
                                    [ngClass]="{ 'animation-scale': !pending && !isItemLoading && !isNavigating }"
                                    class="btn btn-green"
                                    data-testid="btn-order-next"
                                    mat-raised-button
                                >
                                    <span [ngClass]="{ 'btn__loader--invisible': isNavigating || pending }">{{
                                        (routeData && routeData.text ? routeData.text : 'Suivant') | transloco
                                    }}</span>
                                </button>
                            </ng-template>
                        </span>
                        <ng-template #lastStep>
                            <button
                                (click)="routeData && routeData.callback ? callChildrenCallback() : checkout()"
                                [buttonLoader]="(isNavigating || pending) && routeData && !routeData.callback"
                                [disabled]="
                                    (isLoading ||
                                        pending ||
                                        (status$ | async) === 'draft' ||
                                        noTarget ||
                                        isItemLoading ||
                                        isNavigating ||
                                        routeData.nextButtonDisabled) &&
                                    routeData &&
                                    (!routeData.callback || routeData.nextButtonDisabled)
                                "
                                [ngClass]="{
                                    'animation-scale':
                                        !isLoading &&
                                        !pending &&
                                        (status$ | async) !== 'draft' &&
                                        !noTarget &&
                                        !isItemLoading &&
                                        !isNavigating
                                }"
                                class="btn btn-green"
                                data-testid="btn-order-next"
                                mat-raised-button
                                tooltipClass="custom-tooltip custom-tooltip--compact"
                                [tooltip]="!routeData.cguApproved ? ('Veuillez accepter les conditions particulières' | transloco) : null"
                            >
                                <span
                                    [ngClass]="{
                                        'btn__loader--invisible':
                                            (isNavigating || pending) && routeData && !routeData.callback
                                    }"
                                >
                                    {{
                                        item.attributes.trial
                                            ? ("Demarrer l'essai" | transloco)
                                            : (realPrice$ | async)?.amountNoVAT === 0
                                            ? ((routeData && routeData.text ? routeData.text : 'Suivant') | transloco)
                                            : ('Payer' | transloco)
                                    }}</span
                                >
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #loader>
    <app-loader [size]="20" class="price_loader inline"></app-loader>
</ng-template>
<ng-template #superloader>
    <div class="superloader">
        <img src="/assets/images/loader.gif" width="80px" />
    </div>
</ng-template>
<ng-template #spacer>
    <div *ngIf="item && item.setup.status === 'draft'; else loader"></div>
</ng-template>
